import { useQuery } from "@tanstack/react-query";
import { getCourses } from "@/http/coursesApi";
import { getCookie } from "@/utils/cookies";
import { getCoursesQueryKey } from "@/utils/queryKeys";
import type { Course } from "@/@types/courses.types";

export const useGetCoursesQuery = (clubId: string | null) => {
  const userToken = getCookie("user_token");

  return useQuery<Course[]>({
    queryKey: [...getCoursesQueryKey(clubId ?? undefined), { userToken }],
    queryFn: async () => {
      if (!clubId) return [];
      const response = await getCourses(clubId, userToken || undefined);
      return response.data.data ?? [];
    },
    enabled: !!clubId,
  });
};
